/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { createTau } from '../../factoriesAny.js';
export var tauDependencies = {
  BigNumberDependencies,
  createTau
};